import "./setupProcessEnv";
import React from "react";
import ReactDOM from "react-dom";
import "./index.css";

const renderStartupError = () => {
  ReactDOM.render(
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: "sans-serif",
      }}
    >
      Something went wrong
    </div>,
    document.getElementById("root"),
  );
};

const bootstrap = async () => {
  try {
    const { fetchCmsRuntimeEnv } = await import(
      "./services/remoteConfig/remoteConfigService"
    );
    const remoteEnv = await fetchCmsRuntimeEnv();
    Object.assign(process.env, remoteEnv);
  } catch (error) {
    console.error("Error fetching remote env", error);
    renderStartupError();
    return;
  }

  const { default: App } = await import("./App");
  const { store } = await import("./redux/app/store");
  const { Provider } = await import("react-redux");
  const { QueryClient, QueryClientProvider } = await import("react-query");
  const { PersistGate } = await import("redux-persist/integration/react");
  const { persistStore } = await import("redux-persist");

  const persistor = persistStore(store);
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        retry: 1,
      },
    },
  });

  ReactDOM.render(
    <React.StrictMode>
      <Provider store={store}>
        <PersistGate persistor={persistor}>
          <QueryClientProvider client={queryClient}>
            <App />
          </QueryClientProvider>
        </PersistGate>
      </Provider>
    </React.StrictMode>,
    document.getElementById("root")
  );
};

bootstrap();
